/**
 * Iconos de linea, 24 x 24, trazo 1.8. Dibujados a mano para no cargar una
 * libreria entera por diez pictogramas.
 */

const PATHS = {
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z M5 11a7 7 0 0 0 14 0 M12 18v3',
  send: 'M5 12h13 M13 6l6 6-6 6',
  arrow: 'M9 6l6 6-6 6',
  stop: 'M7 7h10v10H7z',
  speaker: 'M4 10v4h4l5 4V6L8 10H4Z M16.5 8.5a5 5 0 0 1 0 7 M19 6a8.5 8.5 0 0 1 0 12',
  speakerOff: 'M4 10v4h4l5 4V6L8 10H4Z M17 9l5 6 M22 9l-5 6',
  link: 'M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1 M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  plus: 'M12 5v14 M5 12h14',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M12 11v5 M12 8h.01',
  history: 'M3 12a9 9 0 1 0 3-6.7 M3 4v4h4 M12 8v4l3 2',
  doc: 'M7 3h7l5 5v13H7z M14 3v5h5 M10 13h6 M10 17h6',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M12 7v5l3.5 2',
  steps: 'M5 6h5v5H5z M14 13h5v5h-5z M10 8.5h4a2 2 0 0 1 2 2V13',
  clip: 'M20 11.5l-8.2 8.2a5 5 0 0 1-7.1-7.1l8.5-8.5a3.3 3.3 0 0 1 4.7 4.7l-8.5 8.5a1.7 1.7 0 0 1-2.4-2.4l7.8-7.8',
  close: 'M6 6l12 12 M18 6L6 18',
  expand: 'M14 4h6v6 M20 4l-7 7 M10 20H4v-6 M4 20l7-7',
  shrink: 'M20 4l-6 6 M14 5v5h5 M4 20l6-6 M10 19v-5H5',
  camera: 'M3 7h4l2-2h6l2 2h4v12H3z M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  cameraOff: 'M3 7h4l2-2h6l2 2h4v12H3z M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z M3 3l18 18',
  play: 'M8 5v14l11-7z',
  image: 'M4 5h16v14H4z M4 16l5-5 4 4 3-3 4 4 M15.5 9.5h.01',
  cap: 'M2 9.5l10-5 10 5-10 5z M6 11.5v4.5c0 1.6 2.7 3 6 3s6-1.4 6-3v-4.5 M22 9.5v5.5',
  award: 'M12 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z M8.7 13.4L7.5 21l4.5-2.6 4.5 2.6-1.2-7.6',
  person: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z M4.5 20.5a7.5 7.5 0 0 1 15 0',
  cc: 'M3 6h18v12H3z M10.5 10.3a2.4 2.4 0 1 0 0 3.4 M17 10.3a2.4 2.4 0 1 0 0 3.4',
  book: 'M5 5.5A2.5 2.5 0 0 1 7.5 3H19v15H7.5A2.5 2.5 0 0 0 5 20.5z M5 20.5V5.5 M9 7.5h6',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name].split(' M').map((d, i) => (
        <path key={i} d={i === 0 ? d : `M${d}`} />
      ))}
    </svg>
  );
}
